var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"text":"","color":"success"}},[_vm._v(" All done, now wait until shipment is delivered! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }